import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateDocumentTemplate } from '@dealstack/frontend/shared/dataExchange/services/documentTemplates.service';
import { UpdateGlobalDocumentTemplateDto } from '@dealstack/shared/lib/generated';
import { useTranslationDefault } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.tsx';
import { showToastV2 } from '@dealstack/frontend/shared/mechanism/toast/useToastV2.tsx';
import { documentTemplateMutationError } from '@dealstack/frontend/app/pages/DocumentTemplates/api/documentTemplateMutationError';
import API_PATHS from '@dealstack/shared/lib/generated/apiPaths';

interface Params {
	id: string;
	body: UpdateGlobalDocumentTemplateDto;
}

export const useUpdateDocumentTemplate = () => {
	const tDefault = useTranslationDefault();
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: ({ id, body }: Params) => updateDocumentTemplate(id, body),
		onSuccess: async (_, { id }) => {
			await queryClient.invalidateQueries({ queryKey: [API_PATHS.DOCUMENT_TEMPLATES_GET] });
			await queryClient.invalidateQueries({
				queryKey: [API_PATHS.DOCUMENT_TEMPLATES_ID_GET, { id }],
			});
			showToastV2({
				title: tDefault('document_templates.toast.updated'),
			});
		},
		onError: (error: unknown) => documentTemplateMutationError(error, tDefault),
	});
};
